<template>
  <ListagemBase
    nomePlural="OperacoesPendentesTransacoes"
    nomeSingular="OperacaoPendenteTransacao"
    :headers="headers"
    :botaoCadastro="false"
    :customRowActions="customRowActions"
    :buscaSimplificada="false"
    :buscaParametrizadaPaginada="true"
    :pesquisaPeriodo="true"
    :pesquisaCpfCnpj="true"
    :pesquisaNome="true"
  />
</template>

<script>
import ListagemBase from "@/components/base/Crud/ListagemBase";
import OperacaoPendenteTransacaoDataService from "@/services/software/OperacaoPendenteTransacaoDataService";

export default {
  name: "ListagemOperacaoPendenteTransacao",
  components: { ListagemBase },
  data() {
    return {
      DataService: OperacaoPendenteTransacaoDataService,
      headers: [
        { text: this.$t("ID"), value: "id", sortable: false },
        { text: this.$t("Nome"), value: "usuarioNome", sortable: false },
        { text: this.$t("Usuario"), value: "usuarioEmail", sortable: false },
        {
          text: this.$t("Metodo_HTTP"),
          value: "tipoRequisicaoHttp",
          sortable: false,
        },
        { text: this.$t("URL"), value: "url", sortable: false },
        {
          text: this.$t("Exige_autenticacao"),
          value: "exigeAutenticacao",
          sortable: false,
        },
        {
          text: this.$t("Status_HTTP_falha"),
          value: "statusHttp",
          sortable: false,
        },
        {
          text: this.$t("Data_de_inclusao"),
          value: "dtInclusao",
          sortable: false,
        },
        {
          text: this.$t("Status_HTTP_execucao"),
          value: "statusHttpExecucao",
          sortable: false,
        },
        { text: this.$t("Acoes"), value: "actions", sortable: false },
      ],
      customRowActions: [
        {
          value: "executar",
          title: "Executar",
          icon: "mdi-play-circle-outline",
          permission: "ROLE_OperacaoPendenteTransacao_List",
          visible: (item) =>
            item?.exigeAutenticacao === false &&
            item?.executadaComSucesso !== true,
          method: "executarTransacao",
          refreshAfter: true,
        },
      ],
    };
  },
  methods: {
    async executarTransacao(item) {
      const confirmation = await this.$swal.fire({
        title: this.$t("Executar_transacao?"),
        text: this.$t("A_execucao_nao_enviara_autenticacao"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Confirmar"),
        cancelButtonText: this.$t("Cancelar"),
      });
      if (!confirmation.isConfirmed && !confirmation.value) {
        return;
      }

      const response = await this.DataService.executar(item.id);
      await this.$swal.fire(
        this.$t("Sucesso"),
        this.$t("Transacao_executada_com_sucesso"),
        "success"
      );
      return response;
    },
  },
};
</script>

<style scoped></style>
